export const MOBILE_BP = 1124;
export const ADDRESS = '01135, м. Київ, Шевченківський р-н., вул. Полтавська, б.10, оф. 302';
export const ADDRESS_LINK = 'https://maps.app.goo.gl/87tDrTW19Say8GzY7';
export const TAX_CODE = 44765447;
export const OWNER = 'Чорний Микола Миколайович';
export const CURRENT_ACCOUNT = 'UA 63 322669 0000026008300645911 АТ «ОЩАДБАНК»';
export const CONTACT_EMAIL = 'bf_uwwt@ukr.net';
export const CONTACT_NUMBER = 380931776909;
